import { render, staticRenderFns } from "./boxformdetail.vue?vue&type=template&id=398b3b2a&"
import script from "./boxformdetail.vue?vue&type=script&lang=js&"
export * from "./boxformdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports